import { getAllCountriesCode } from './getAllCountriesCode'

interface IGetSeparatedPhone {
  phone: string
  phoneCode?: string
}

/**
 * Function splits phone into code country and local number
 *
 * P.S. Consider extracting this helper to the common layer
 */
export const getSeparatedPhone = ({ phone = '', phoneCode }: IGetSeparatedPhone) => {
  const countriesCode = getAllCountriesCode()

  const separated = {
    phone,
    code: '',
  }

  const formattedPhone = separated.phone.replace(/(^[+]?0*)|\D/g, '')

  if (phoneCode) {
    if (formattedPhone.startsWith(phoneCode)) {
      separated.phone = formattedPhone.substring(phoneCode.length)
      separated.code = phoneCode
    } else {
      separated.code = phoneCode
    }
  } else {
    for (let codeLen = 3; codeLen > 0; codeLen--) {
      const countryCode = formattedPhone.substring(0, codeLen)
      if (countriesCode[countryCode]) {
        separated.code = countryCode
        separated.phone = formattedPhone.substring(codeLen)
      }
    }
  }

  return separated
}
